import { ref } from 'vue';
import { timezoneToCountryMap } from '@/data/timezoneToCountry';
import { countryToCurrencyMap } from '@/data/countryToCurrency';

const getCountryFromLanguage = () => {
  try {
    if (typeof window !== 'undefined' && navigator.language) {
      const locale = new Intl.Locale(navigator.language);
      if (locale.region) {
        return locale.region.toLowerCase();
      }
    }

    if (typeof window !== 'undefined' && navigator.languages) {
      for (const lang of navigator.languages) {
        try {
          const locale = new Intl.Locale(lang);
          if (locale.region) {
            return locale.region.toLowerCase();
          }
        } catch {
          /* ignore */
        }
      }
    }
  } catch (error) {
    console.warn('[useGeolocation] Error parsing language:', error.message);
  }
  return null;
};

const getCountryFromTimezone = () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezone && timezoneToCountryMap[timezone]) {
      return timezoneToCountryMap[timezone];
    }
  } catch (error) {
    console.warn('[useGeolocation] Error getting timezone:', error.message);
  }
  return null;
};

export const getCountryCodeForAddonsRequest = () => getCountryFromTimezone();

const getCurrencyFromCountry = (countryCode) => {
  if (!countryCode) {
    return null;
  }
  return countryToCurrencyMap[countryCode] || null;
};

export const useGeolocation = ({ autoDetect = true } = {}) => {
  const userCountryCode = ref(null);
  const userCurrency = ref(null);

  const detectUserLocationAndCurrency = () => {
    try {
      let countryCode = getCountryFromLanguage();
      if (!countryCode) {
        countryCode = getCountryFromTimezone();
      }

      if (
        countryCode &&
        countryCode.length === 2 &&
        /^[a-z]{2}$/.test(countryCode)
      ) {
        userCountryCode.value = countryCode;
        const currency = getCurrencyFromCountry(countryCode);
        if (currency) {
          userCurrency.value = currency;
        }
      }
    } catch (error) {
      console.warn(
        '[useGeolocation] Failed to detect location:',
        error.message,
      );
    }
  };

  if (autoDetect && typeof window !== 'undefined') {
    detectUserLocationAndCurrency();
  }

  return {
    detectUserLocationAndCurrency,
    userCountryCode,
    userCurrency,
  };
};
